import { useContext, useEffect, useMemo, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/esm/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CoachDataDispatch, ViewsDispatch } from '../App';
import { parishes } from '../data';
import { Context } from '../context';
import uuid from 'uuid';
import { Link } from 'react-router-dom';

function Coach() {
  const viewDispatch = useContext(ViewsDispatch);
  const { _coachDataState: state, coachDataDispacth: dispatch} = useContext(CoachDataDispatch);
  const {state: { clubs }, getClubs , addCoach , coachEmailExists} = useContext(Context);
  const [has_error , setHasError ] = useState(false);
  const [error_message , setErrorMessage] = useState("");
  const [addSucess , setAddSuccess] = useState(false);
  const [organization_type , setOrganizationType] = useState("");
  const [duplicate , setDuplicate] = useState(false);
  useEffect(() => {
                  getClubs();
                }, []);
  useEffect(()=>{
    if(!state.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){
      setDuplicate(false);
      return;
    }
    isDuplicateEmail();
  },[state.email]);
  const selected_clubs = useMemo(()=>{
    return clubs.filter((club)=>  club.organization_type === organization_type);
  },[clubs , organization_type]);

  async function isDuplicateEmail(){
    try{
      const items = await coachEmailExists(state.email);
      if(items.length !== 0){
        setDuplicate(true);
        return;
      }
      setDuplicate(false);
    }
    catch(err){
      console.log(err);
    }
  }
function PageHeader (){
  return(  <div style={{display : "flex" , justifyContent : "space-between" , marginBottom : 16}}>
           <img alt="AAB" src="AABLogo.png" className="mb-1 aab-logo" style={{marginRight : 8}} width={100}/>
            <img src="pumalogo.png" alt="puma" width={100} className="mb-3 puma-logo"/>            
          </div>)
}
  function handleClubSelect(e){
    dispatch({ type: 'clubID', value: e.target.value });
  } 
  const handleHomeChange = e => {
    const value = e.target.value;
    if (value && !value.match('^[0-9]+$')) {
      return;
    }
    dispatch({ type: 'home', value });
  };
  const handleMobileChange = e => {
    const value = e.target.value;
    if (value && !value.match('^[0-9]+$')) {
      return;
    }
    dispatch({ type: 'mobile', value });
  };
  const handleSubmit = async ()=>{
    const {first_name ,middle_name ,last_name ,address  ,parish  ,home  ,mobile  ,email ,clubID } = state;
    if(!first_name || !last_name || !email || !clubID){
      setHasError(true);
      setErrorMessage("Required Values are Missing!!");
      return;
    }
    if(!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){
      setHasError(true);
      setErrorMessage("Invalid Email Address!!");
      return;
    }
    if(duplicate){
      setHasError(true);
      setErrorMessage("Email previously registered!!");
      return;
    }
    try{
      const d = new Date().getFullYear() % 2000;
      const id = 'AAB-' + String(d) + uuid.v4().split('-')[4].slice(0,4).toUpperCase();
      await addCoach({id , first_name ,middle_name ,last_name ,address  ,parish  ,home  ,mobile  ,email ,clubID });
      setAddSuccess(true);
    }
    catch(err){
      console.log(err);
    }
  };
  function handleCancelClicked(){
    dispatch({type : "RESET_STATE"});
    viewDispatch({ value: 'loading' });
    setTimeout(() => viewDispatch({ value: 'home' }), 1000);
  }
    return (
      <Container fluid style={{ minHeight: 400, width: '80%', backgroundColor: 'white', paddingTop : 16 }} className="d-flex flex-column">
        <div style={{ minHeight: 600 }}>
          <PageHeader/>
      <h2>Coach Registration Information</h2>
      <div className="border border-bottom" />
      {
        addSucess ?
        <div style={{ minHeight: 500 }}>
          <h4>Form Submitted</h4>
          <p>Your application has been submitted to the Athletics Association of Barbados. Please check your email for confirmation.</p>
        </div> :
        <Form>
          <Form.Group>
            <Form.Text>
              1a. What type of Organization are you registering with?<p className="mb-0 text-danger d-inline">*</p>
            </Form.Text>
            <Row>
              <Col>
                <Form.Check
                  type="radio"
                  label="School"
                  required
                  checked={organization_type === 'school'}
                  onChange={() =>setOrganizationType('school')}
                />
                <Form.Check
                  type="radio"
                  label="Club"
                  required
                  checked={organization_type === 'club'}
                  onChange={() => setOrganizationType('club')}
                />
              </Col>
            </Row>
              <Form.Text>
                {
                  organization_type === 'club' ?
                  <Form.Text>b. Name of Club <p className="mb-0 text-danger d-inline">*</p></Form.Text> :
                  organization_type === 'school' ?
                  <Form.Text>b. Name of School <p className="mb-0 text-danger d-inline">*</p> </Form.Text> :
                  null
                }
              </Form.Text>
            {
              organization_type &&
              <Row>
                <Col>
                <Form.Control  as="select"  onChange={handleClubSelect} style={{border : !state.clubID && has_error ? styles.error.border : null}}>
                    <option label="-- Please Select --" value="">
                      -- Please Select --
                    </option>
                    {  selected_clubs.map(club => (<option key={club.id} label={club.name} value={club.id}>{club.name}</option>)) }
                  </Form.Control>
                </Col>
              </Row>
            }
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              2. Name Of Coach ( Please provide first, middle and surname)
            </Form.Text>
            <Row className="info-row">
              <Col className="info-input">
                <Form.Control
                  placeholder="First name"
                  onChange={e => dispatch({   type: 'first_name',   value: e.target.value, })}
                  value={state.first_name}
                  style={{border : !state.first_name && has_error ? styles.error.border : null}}
                />
              </Col>
              <Col className="info-input">
                <Form.Control
                  placeholder="Middle name"
                  onChange={e =>
                    dispatch({
                      type: 'middle_name',
                      value: e.target.value,
                    })
                  }
                  value={state.middle_name}
                />
              </Col>
              <Col className="info-input">
                <Form.Control
                  placeholder="Surname"
                  onChange={e =>
                    dispatch({
                      type: 'last_name',
                      value: e.target.value,
                    })
                  }
                  value={state.last_name}
                  style={{border : !state.last_name && has_error ? styles.error.border : null}}
                />
              </Col>
            </Row>
          </Form.Group>
          <Form.Group>
            <Form.Text>
              3.  Home Address (Apt/House Number, Street Address)
            </Form.Text>
            <Form.Control
              placeholder="Enter address..."
              onChange={e =>
                dispatch({ type: 'address', value: e.target.value })
              }
              value={state.address}
            />
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              4. Parish
              </Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }}
                  as="select"
                  value={state.parish}
                  onChange={e =>
                    dispatch({ type: 'parish', value: e.target.value })
                  }
                >
                  <option value="">--- Select Parish ---</option>
                  {parishes.map((parish, index) => (
                    <option value={parish} key={index}>
                      {parish}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>5. Home (e.g. 5433210)</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }}
                  type="tel"
                  onChange={handleHomeChange}
                  value={state.home}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>6. Mobile (e.g. 5433210)</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }}
                  type="tel"
                  onChange={handleMobileChange}
                  value={state.mobile}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>7. Email Address</Form.Text>
            <Row>
              <Col style={{display : "flex" , alignItems : "center"}}>
                <Form.Control
                  type="email"
                  onChange={e =>dispatch({ type: 'email', value: e.target.value })}
                  value={state.email}
                  style={{width: 300 ,border :  (((!state.email || !state.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))  && has_error) || duplicate) ? styles.error.border : null}}
                />
              { duplicate && <p className="text-danger mb-0" style={{fontSize : 12 ,marginLeft : 8}}>Email previously registered</p>}
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
        </Form>
      }
    </div>
    {
      !addSucess &&
      <div className="mt-2 d-flex justify-content-center mb-2">
          <Button className="mr-2" variant="success" onClick={handleSubmit}>Submit</Button>
          <Link to="/"><Button onClick={handleCancelClicked}  variant="light text-muted">  Cancel</Button></Link>
      </div>
    }
      {has_error && (
        <Alert show variant="danger">
          {error_message}
        </Alert>
      )}
      </Container>
    );
}
const styles = {
  error: {
    border: '1px solid red',
  },
};
export default Coach;
